import { Box } from '@unifyapps/ui/components/Box';
import { Link } from '@unifyapps/ui/components/Link';
import { Typography } from '@unifyapps/ui/components/Typography';
import { clsx } from 'clsx';
import { useMemo } from 'react';
import { DATA_NAV_ITEM_ATTRIBUTE } from '../../../constants';
import type { NavItem } from '../../../types';
import { resolveOpenInNewTab } from '../../../utils/redirection';
import { navItemContentVariants, navItemLabelVariants } from '../styles';
import { Icon } from './Icon';

type Props = {
  navItem: NavItem;
  isActive: boolean;
  className?: string;
  readonly?: boolean;
};

export function UrlItem({ navItem, isActive: active, className, readonly }: Props) {
  const { id, name, url, icon, activeIcon, endIcon, activeEndIcon } = navItem;
  const openInNewTab = resolveOpenInNewTab(navItem);

  const redirectionProps = useMemo(
    () => (openInNewTab ? { target: '_blank' as const } : {}),
    [openInNewTab],
  );

  const navItemContentClassName = navItemContentVariants({
    active,
  });

  const navItemLabelClassName = navItemLabelVariants({
    active,
  });

  return (
    <Link
      href={readonly ? '#' : url}
      underline="none"
      {...redirectionProps}
      {...{ [DATA_NAV_ITEM_ATTRIBUTE]: id }}
      className={clsx('h-10 items-center rounded-sm', className)}
    >
      <Box className={navItemContentClassName}>
        <Icon active={active} activeIcon={activeIcon} icon={icon} />
        <Typography className={navItemLabelClassName} weight="medium">
          {name}
        </Typography>
        {endIcon ? (
          <Box className="ms-auto">
            <Icon active={active} activeIcon={activeEndIcon} icon={endIcon} />
          </Box>
        ) : null}
      </Box>
    </Link>
  );
}
